import React from 'react';
import SlackChannel from '../components/Slack/SlackChannel';

const SlackChannelPage = () => {
  return <SlackChannel />;
};

export default SlackChannelPage;
